import React, { useState, useEffect } from "react";
import { getUserProjects } from "./myFunctions";
import { db,auth } from "../firebase";
import { Link, useNavigate } from "react-router-dom";
import { collection, onSnapshot, query, where, deleteDoc, doc, getDoc } from "firebase/firestore";


const ProjectTable = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    // Check if the user is authenticated
    const currentUser = auth.currentUser;
    console.log(auth.currentUser);
    if (!currentUser) {
      // Handle the case where the user is not authenticated
      console.log("User not authenticated");
      return;
    }
  
    // Call the getUserProjects function when the component mounts
    getUserProjects(currentUser.uid).then((projects) => {
      console.log("Setting projects state to:", projects);
      setProjects(projects);
    });

    /*
    const q = query(collection(db, "projects"), where("ownerId", "==", currentUser.uid));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const projects = [];
      querySnapshot.forEach((doc) => {
        projects.push({ id: doc.id, ...doc.data() });
      });
      setProjects(projects);
    });

    return () => {
      unsubscribe();
    };
    */

  }, []);

  const navigate = useNavigate();

  const handleEditProject = (id) => {
    navigate(`/datasets/${id}`);
  };

  const handleDeleteProject = async (id) => {
    try {
      const projectsRef = collection(db, "users_projects");
      const projectDoc = await getDoc(doc(projectsRef, id));
  
      // Check if project exists
      if (!projectDoc.exists()) {
        throw new Error("Project not found");
      }
  
      // Delete project
      await deleteDoc(doc(projectsRef, id));
      console.log(`Project with ID ${id} deleted successfully`);
    } catch (error) {
      console.error("Error deleting project: ", error.message);
    }
  };

  return (
    <table>
      <thead>
        <tr>
          <th>Project Name </th>
          <th>Status </th>
          <th>Created At </th>
          <th>Updated At </th>
          <th>Edit </th>
          <th>Delete </th>
        </tr>
      </thead>
      <tbody>
        {projects.map((project) => (
          <tr key={project.id}>
            <td>{project.projectName}</td>
            <td>{project.status}</td>
            <td>{project.createdAt}</td>
            <td>{project.updatedAt}</td>
            <td>
              <button onClick={() => handleEditProject(project.id)}>Edit</button>
            </td>
            <td>
              <button onClick={() => handleDeleteProject(project.id)}>Delete</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ProjectTable;
